/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import OwlCarousel from "react-owl-carousel2";
import BlogCard from "modules/blogs/components/BlogCard";
import { getFormattedDate } from "utils";
import NoList from "components/NoList";
import "react-owl-carousel2/lib/styles.css";
import useWindowWidth from "components/UseWindowWidth";
import ImageButton from "./ImageButton";

const Blogs = React.memo(({ list }) => {
  const [carouselOptions, setCarouselOptions] = useState({
    items: 4,
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    navText: [
      '<img src="/img/arrow-button-left.svg" id="custom-prev">',
      '<img src="/img/arrow-button-right.svg" id="custom-next">',
    ],
  });

  const width = useWindowWidth();

  const history = useHistory();

  const [isHovered, setIsHovered] = useState(false);
  const [buttonId, setButtonId] = useState();

  const handleMouseEnter = (id) => {
    setIsHovered(true);
    setButtonId(id);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setButtonId("");
  };

  useEffect(() => {
    if (width < 768) {
      // On mobile screens, display 2 items
      setCarouselOptions({ ...carouselOptions, items: 1.5 });
    } else if (width > 1600) {
      setCarouselOptions({ ...carouselOptions, items: 4 });
    } else {
      // On larger screens (desktop), display 5 items
      setCarouselOptions({ ...carouselOptions, items: 3 });
    }
  }, []);

  console.log("carousel options", carouselOptions);

  console.log("carousel list is", list);

  return (
    // <section className="news-events-wrapper">
    //   <div className="container">
    //     <div className="row newsevents-main">
    //       <div className="news-events-head-wrapper">
    //         <div className="newshead-wrapper wow fadeInUp">
    //           <div className="news-icon">
    //             <img
    //               src="/resources/img/sabinehospital-icons/sabinehospital-calender-icon.svg"
    //               alt=""
    //             />
    //           </div>
    //           <div className="news-head-section">
    //             <h3>
    //               <span>Latest</span> News & Events
    //             </h3>
    //             <div className="secparator-icon">
    //               <img
    //                 src="/resources/img/sabinehospital-icons/sabinehospital-heartbeat.svg"
    //                 alt=""
    //               />
    //             </div>

    //             {list &&
    //               list.length > 0 && (
    //                 <div className="btn-wrapper">
    //                   <Link to="/blogs" className="btn big-btn">
    //                     View All <i className="fas fa-arrow-right" />
    //                   </Link>
    //                 </div>
    //               )}
    //           </div>
    //         </div>
    //       </div>

    //       <div className="newsevents-slider-wrapper wow fadeInUp">
    //         {list && list.length > 0 && (
    //           <OwlCarousel
    //             options={carouselOptions}
    //             className="owl-carousel owl-theme newsevents-slider nav-right-top"
    //           >
    //             {list.map(item => (
    //               <div key={item._id} className="item">
    //                 <BlogCard
    //                   {...item}
    //                   id={item._id}
    //                   imageTag={item.imageTag}
    //                   image = {`${process.env.REACT_APP_BASE_URL}/${item.image.url}`}
    //                   thumbnail={item.image.thumbnail}
    //                   date={getFormattedDate(item.updatedAt, 'DD MMM YYYY')}
    //                 />
    //               </div>
    //             ))}
    //           </OwlCarousel>
    //         )}
    //         {(!list || (list.length === 0)) && <NoList message="No blogs to display" />}
    //       </div>
    //     </div>
    //   </div>
    // </section>
    <>
      <div className="news-events-outer-div">
        <div className="news-events-titles ">
          <div className="stay-connected-outer">
            <img
              className="stay-connected-diamond"
              src="/img/diamonds-mobile.svg"
            />
            <div className="stay-connected-div wow">
              <img className="mobile-stars" src="/img/diamonds-mobile.svg" />
              <h3>News & Events</h3>

              <h2>
                Stay Connected: News
                <br /> & Events
              </h2>
            </div>
          </div>
        </div>
        <div className="news-events-list news-events-mobile-margin">
          <img className="news-ev-pattern" src="/img/news-events-pattern.svg" />
          <OwlCarousel
            options={carouselOptions}
            className="owl-carousel owl-theme news-events-arrow  wow fadeInUp nav-middle"
          >
            {list.map((item) => (
              <div className="blog-outer-div">
                <div className="blog-image">
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}/${item.image.url}`}
                  />
                </div>
                <h3 className="diagnose-male">{item.title}</h3>
                <p className="male-infertility">{item.shortDescription}</p>
                {/* <button
                  id={item._id}
                  onMouseEnter={() => {
                    handleMouseEnter(item._id);
                  }}
                  onMouseLeave={handleMouseLeave}
                  onClick={()=>history.push(`/blogs/${item.slug}`)}
                >
                  Know More
                  <img
                    src={
                      buttonId != item._id
                        ? "/img/pink-arrow.svg"
                        : "/img/arrow-right.svg"
                    }
                  />
                </button> */}
                <ImageButton
                  defaultImage="/img/pink-arrow.svg"
                  hoverImage="/img/arrow-right.svg"
                  text = "Know More"
                  redirectUrl={`/blogs/${item.slug}`}
                />
              </div>
            ))}
          </OwlCarousel>
        </div>
      </div>
      <div className="blogs-day-view-div">
        <button
          onClick={() => history.push("/blogs")}
          onMouseEnter={() => {
            handleMouseEnter("newsViewAll");
          }}
          onMouseLeave={handleMouseLeave}
          id="newsViewAlll"
          className="photo-day-view"
        >
          View All
          <img
            src={
              buttonId == "newsViewAll"
                ? "/img/arrow-right-big.svg"
                : "/img/arrow-right.svg"
            }
          />
        </button>
      </div>
    </>
  );
});

export default Blogs;
